// Simple Quick Add Popup Implementation
(function() {
  'use strict';
  
  let isInitialized = false;
  
  function initQuickAddPopup() {
    if (isInitialized) return;
    isInitialized = true;
    
    console.log('Initializing Quick Add Popup');
    
    // Check if quick add buttons exist (desktop and mobile)
    const quickAddButtons = document.querySelectorAll('.card__quick-add-btn, .card__mobile-quick-add-btn');
    console.log('Found quick add buttons:', quickAddButtons.length);
    
    // Bind click events to quick add buttons
    document.addEventListener('click', function(e) {
      console.log('Click detected on:', e.target);
      // Check if clicked element is a quick add button (desktop or mobile)
      if (e.target.closest('.card__quick-add-btn') || e.target.closest('.card__mobile-quick-add-btn')) {
        console.log('Quick add button found!');
        e.preventDefault();
        e.stopPropagation();
        
        const button = e.target.closest('.card__quick-add-btn') || e.target.closest('.card__mobile-quick-add-btn');
        const productId = button.getAttribute('data-product-id');
        
        console.log('Quick add button clicked for product:', productId);
        console.log('Button element:', button);
        
        if (productId) {
          openPopup(productId);
        } else {
          console.error('No product ID found on button');
        }
      } else if(e.target.classList.contains('card__quick-add-overlay')){
        let purl = e.target.dataset.url;
        window.location.href=purl;
      }
      
      // Handle popup close
      if (e.target.closest('.quick-add-popup-close') || 
          e.target.closest('.quick-add-popup-overlay')) {
        e.preventDefault();
        closePopup();
      }
      
      // Handle frame radio selection
      if (e.target.closest('.quick-add-popup-radio input[type="radio"]')) {
        e.stopPropagation();
        const radio = e.target;
        const modal = radio.closest('.quick-add-popup-modal');
        selectFrame(modal, radio);
      }
      
      // Handle size box selection
      if (e.target.closest('.quick-add-popup-size-box')) {
        e.preventDefault();
        e.stopPropagation();
        const button = e.target.closest('.quick-add-popup-size-box');
        const modal = button.closest('.quick-add-popup-modal');
        selectSize(modal, button);
      }
      
      // Handle add to cart button
      if (e.target.closest('.quick-add-popup-add-to-cart')) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Add to cart button clicked');
        const button = e.target.closest('.quick-add-popup-add-to-cart');
        const modal = button.closest('.quick-add-popup-modal');
        addToCart(modal);
      }
    });
    
    // Handle escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closePopup();
      }
    });
    
    // Handle variant changes inside popup variant-selects
    document.addEventListener('change', function(e) {
      const inPopupVariantSelects = e.target.closest('.quick-add-popup-modal variant-selects');
      if (inPopupVariantSelects) {
        const modal = e.target.closest('.quick-add-popup-modal');
        handleVariantChange(modal);
        return;
      }

      // Legacy handler (kept for backward compatibility if custom classes exist)
      if (e.target.closest('.quick-add-popup-radio input[type="radio"]')) {
        const radio = e.target;
        const modal = radio.closest('.quick-add-popup-modal');
        selectFrame(modal, radio);
      }
    });
  }
  
  function openPopup(productId) {
    console.log('Opening popup for product:', productId);
    
    // Close any existing popups
    closeAllPopups();
    
    const modalId = 'quick-add-modal-' + productId;
    console.log('Looking for modal with ID:', modalId);
    
    const modal = document.getElementById(modalId);
    console.log('Modal element found:', modal);
    
    if (modal) {
      console.log('Setting modal display to flex');
      modal.style.display = 'flex';
      modal.style.zIndex = '10000';
      document.body.style.overflow = 'hidden';
      
      // Focus close button
      const closeButton = modal.querySelector('.quick-add-popup-close');
      if (closeButton) {
        closeButton.focus();
      }
      
      // Only reset form state if no selections have been made
      const hasActiveSelections = modal.querySelector('.quick-add-popup-radio input[type="radio"]:checked') || 
                                 modal.querySelector('.quick-add-popup-size-box.active');
      
      if (!hasActiveSelections) {
        resetForm(modal);
      }
      
      // Check initial variant availability
      checkVariantAvailability(modal);
      if(document.querySelectorAll('.community-gallery-main-container').length > 0){
        document.querySelector('.community-gallery-main-container').style.zIndex = '-1';
      }
      if(document.querySelectorAll('.section-header.shopify-section-group-header-group').length>0){
        document.querySelector('.section-header.shopify-section-group-header-group').style.zIndex = '-1';
      }
      console.log('Popup opened successfully');
    } else {
      console.error('Modal not found for product:', productId);
      console.error('Available modals:', document.querySelectorAll('.quick-add-popup-modal'));
    }
  }
  
  function closePopup() {
    const openModal = document.querySelector('.quick-add-popup-modal[style*="flex"]');
    if (openModal) {
      openModal.style.display = 'none';
      document.body.style.overflow = '';
    }
    if(document.querySelectorAll('.community-gallery-main-container').length > 0){
      document.querySelector('.community-gallery-main-container').style.zIndex = 'unset';
    }
    if(document.querySelectorAll('.section-header.shopify-section-group-header-group').length>0){
      document.querySelector('.section-header.shopify-section-group-header-group').style.zIndex = 'revert-layer';
    }
  }
  
  function closeAllPopups() {
    const allModals = document.querySelectorAll('.quick-add-popup-modal');
    allModals.forEach(function(modal) {
      modal.style.display = 'none';
    });
    document.body.style.overflow = '';
  }
  
  function selectFrame(modal, selectedRadio) {
    console.log('selectFrame called with:', selectedRadio);
    console.log('Radio button checked:', selectedRadio.checked);
    console.log('Radio button value:', selectedRadio.value);
    
    // Radio buttons handle their own selection, just log the value
    const selectedValue = selectedRadio.value;
    console.log('Frame selected:', selectedValue);
    
    // Verify the selection is working
    const allRadios = modal.querySelectorAll('.quick-add-popup-radio input[type="radio"]');
    console.log('All radio buttons in modal:', allRadios.length);
    allRadios.forEach((radio, index) => {
      console.log(`Radio ${index}:`, {
        value: radio.value,
        checked: radio.checked,
        name: radio.name
      });
    });
    
    // Check variant availability and update button
    checkVariantAvailability(modal);
  }
  
  function selectSize(modal, selectedButton) {
    console.log('=== SELECT SIZE CALLED ===');
    console.log('Selected button:', selectedButton);
    console.log('Selected button text:', selectedButton.textContent);
    console.log('Selected button data-size-value:', selectedButton.dataset.sizeValue);
    
    // Remove active class from all size boxes
    const sizeBoxes = modal.querySelectorAll('.quick-add-popup-size-box');
    console.log('Found size boxes:', sizeBoxes.length);
    sizeBoxes.forEach((btn, index) => {
      console.log(`Removing active from size box ${index}:`, btn.textContent, 'was active:', btn.classList.contains('active'));
      btn.classList.remove('active');
    });
    
    // Add active class to selected button
    selectedButton.classList.add('active');
    console.log('Added active class to:', selectedButton.textContent);
    
    // Verify the selection
    const activeSizeBox = modal.querySelector('.quick-add-popup-size-box.active');
    console.log('Active size box after selection:', activeSizeBox ? activeSizeBox.textContent : 'None');
    console.log('Active size box data-value:', activeSizeBox ? activeSizeBox.dataset.sizeValue : 'None');
    console.log('Size selected:', selectedButton.dataset.sizeValue);
    
    // Double-check all size boxes after selection
    console.log('=== ALL SIZE BOXES AFTER SELECTION ===');
    sizeBoxes.forEach((btn, index) => {
      console.log(`Size box ${index}:`, {
        text: btn.textContent,
        active: btn.classList.contains('active'),
        dataValue: btn.dataset.sizeValue
      });
    });
    
    // Check variant availability and update button
    checkVariantAvailability(modal);
  }
  
  function checkVariantAvailability(modal) {
    console.log('=== CHECKING VARIANT AVAILABILITY ===');
    const productId = modal.id.replace('quick-add-modal-', '');
    const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');

    const variantDataScript = document.getElementById(`product-variants-${productId}`);
    if (!variantDataScript) {
      console.error('No variant data found');
      updateButtonState(addToCartBtn, false, 'ERROR - NO DATA');
      return;
    }

    const variantData = JSON.parse(variantDataScript.textContent);
    const { selectedValues, allSelected } = getSelectedOptionsFromVariantSelects(modal, variantData);

    console.log('Selected values (ordered):', selectedValues, 'allSelected:', allSelected);

    if (!allSelected) {
      updateButtonState(addToCartBtn, false, 'SELECT OPTIONS');
      modal.dataset.selectedVariantId = '';
      return;
    }

    const matchingVariant = findVariantByOrderedValues(variantData, selectedValues);
    if(matchingVariant.price){
      // modal.querySelector('.quick-add-popup-current-price').innerText
    }

    if (matchingVariant && matchingVariant.available === true) {
      modal.dataset.selectedVariantId = String(matchingVariant.id);
      updateButtonState(addToCartBtn, true, 'ADD TO CART');
    } else {
      modal.dataset.selectedVariantId = '';
      updateButtonState(addToCartBtn, false, 'NOT AVAILABLE');
    }
  }
  
  function updateButtonState(button, isAvailable, text) {
    console.log('Updating button state:', { isAvailable, text });
    
    button.textContent = text;
    button.disabled = !isAvailable;
    
    if (isAvailable) {
      button.style.background = '#E54B4B';
      button.style.cursor = 'pointer';
    } else {
      button.style.background = '#999';
      button.style.cursor = 'not-allowed';
    }
  }
  
  function findMatchingVariantFromData(variantData, selectedFrame, selectedSize) {
    console.log('=== FINDING MATCHING VARIANT ===');
    console.log('Selected frame:', selectedFrame);
    console.log('Selected size:', selectedSize);
    console.log('Total variants:', variantData.variants.length);
    
    // First, filter to only available variants
    const availableVariants = variantData.variants.filter(variant => {
      console.log(`Checking availability for ${variant.title}: ${variant.available}`);
      return variant.available === true;
    });
    
    console.log('Available variants count:', availableVariants.length);
    console.log('Available variants:', availableVariants);
    
    if (availableVariants.length === 0) {
      console.log('No available variants found');
      return null;
    }
    
    // Debug: Show all available variants with their options in detail
    console.log('=== ALL AVAILABLE VARIANTS DEBUG ===');
    availableVariants.forEach((variant, index) => {
      console.log(`Available Variant ${index}:`, {
        id: variant.id,
        title: variant.title,
        options: variant.options,
        available: variant.available,
        price: variant.price
      });
    });
    
    // Try to find a variant that matches both selected options (only from available variants)
    const matchingVariant = availableVariants.find(variant => {
      console.log('=== CHECKING AVAILABLE VARIANT ===');
      console.log('Variant title:', variant.title);
      console.log('Variant options:', variant.options);
      console.log('Variant available:', variant.available);
      console.log('Looking for frame:', selectedFrame);
      console.log('Looking for size:', selectedSize);
      
      // Check if this variant has both the selected frame and size
      const hasFrame = selectedFrame ? variant.options.includes(selectedFrame) : true;
      const hasSize = selectedSize ? variant.options.includes(selectedSize) : true;
      
      console.log(`Variant ${variant.title}: hasFrame=${hasFrame}, hasSize=${hasSize}`);
      console.log('Frame check details:', {
        selectedFrame,
        variantOptions: variant.options,
        includesFrame: selectedFrame ? variant.options.includes(selectedFrame) : 'N/A (no frame selected)'
      });
      console.log('Size check details:', {
        selectedSize,
        variantOptions: variant.options,
        includesSize: selectedSize ? variant.options.includes(selectedSize) : 'N/A (no size selected)'
      });
      
      // Only return true if variant matches (availability already checked)
      const matches = hasFrame && hasSize;
      console.log(`Variant ${variant.title} matches: ${matches}`);
      return matches;
    });
    
    if (matchingVariant) {
      console.log('Found exact match from available variants:', matchingVariant);
      return matchingVariant;
    }
    
    // If no exact match, try case-insensitive matching (only from available variants)
    console.log('No exact match found, trying case-insensitive match...');
    const caseInsensitiveMatch = availableVariants.find(variant => {
      const hasFrame = selectedFrame ? variant.options.some(option =>
        option.toLowerCase() === selectedFrame.toLowerCase()
      ) : true;
      const hasSize = selectedSize ? variant.options.some(option =>
        option.toLowerCase() === selectedSize.toLowerCase()
      ) : true;
      
      console.log(`Case-insensitive check for ${variant.title}: hasFrame=${hasFrame}, hasSize=${hasSize}`);
      return hasFrame && hasSize;
    });
    
    if (caseInsensitiveMatch) {
      console.log('Found case-insensitive match:', caseInsensitiveMatch);
      return caseInsensitiveMatch;
    }
    
    // If no exact match, try to find a variant that has at least one of the selected options (only from available variants)
    console.log('No case-insensitive match found, trying partial match...');
    const partialMatch = availableVariants.find(variant => {
      const hasFrame = selectedFrame ? variant.options.includes(selectedFrame) : true;
      const hasSize = selectedSize ? variant.options.includes(selectedSize) : true;
      
      console.log(`Partial match check for ${variant.title}: hasFrame=${hasFrame}, hasSize=${hasSize}`);
      return (hasFrame || hasSize);
    });
    
    if (partialMatch) {
      console.log('Found partial match:', partialMatch);
      return partialMatch;
    }
    
    // If still no match, try to match by option position (more sophisticated matching) - only from available variants
    console.log('Trying option position matching...');
    const optionPositionMatch = availableVariants.find(variant => {
      console.log('=== OPTION POSITION MATCHING ===');
      console.log('Variant:', variant.title);
      console.log('Variant options:', variant.options);
      console.log('Product options:', variantData.options);
      
      let frameMatch = true;
      let sizeMatch = true;
      
      // Try to match frame by position
      if (selectedFrame && variantData.options.length > 0) {
        const frameOptionIndex = variantData.options.findIndex(option => 
          option.name.toLowerCase().includes('frame') || 
          option.name.toLowerCase().includes('canvas') || 
          option.name.toLowerCase().includes('type') ||
          option.name.toLowerCase().includes('style')
        );
        
        if (frameOptionIndex !== -1) {
          frameMatch = variant.options[frameOptionIndex] === selectedFrame;
          console.log(`Frame position match: index=${frameOptionIndex}, variantValue="${variant.options[frameOptionIndex]}", selected="${selectedFrame}", match=${frameMatch}`);
        }
      }
      
      // Try to match size by position
      if (selectedSize && variantData.options.length > 1) {
        const sizeOptionIndex = variantData.options.findIndex(option => 
          option.name.toLowerCase().includes('size') || 
          option.name.toLowerCase().includes('dimension')
        );
        
        if (sizeOptionIndex !== -1) {
          sizeMatch = variant.options[sizeOptionIndex] === selectedSize;
          console.log(`Size position match: index=${sizeOptionIndex}, variantValue="${variant.options[sizeOptionIndex]}", selected="${selectedSize}", match=${sizeMatch}`);
        }
      }
      
            console.log(`Option position check for ${variant.title}: frameMatch=${frameMatch}, sizeMatch=${sizeMatch}`);
            return frameMatch && sizeMatch;
    });
    
    if (optionPositionMatch) {
      console.log('Found option position match:', optionPositionMatch);
      return optionPositionMatch;
    }
    
    // If still no match, try to find any available variant that has the selected size
    if (selectedSize) {
      console.log('Trying to match by size only...');
      const sizeMatch = availableVariants.find(variant => {
        const hasSize = variant.options.includes(selectedSize);
        console.log(`Variant ${variant.title}: hasSize=${hasSize}`);
        return hasSize;
      });
      
      if (sizeMatch) {
        console.log('Found size match:', sizeMatch);
        return sizeMatch;
      }
    }
    
    // If still no match, try to find any available variant that has the selected frame
    if (selectedFrame) {
      console.log('Trying to match by frame only...');
      const frameMatch = availableVariants.find(variant => {
        const hasFrame = variant.options.includes(selectedFrame);
        console.log(`Variant ${variant.title}: hasFrame=${hasFrame}`);
        return hasFrame;
      });
      
      if (frameMatch) {
        console.log('Found frame match:', frameMatch);
        return frameMatch;
      }
    }
    
    console.log('=== NO MATCHING VARIANT FOUND ===');
    console.log('Final attempt - showing all available variants:');
    availableVariants.forEach((variant, index) => {
      console.log(`Available Variant ${index}:`, {
        id: variant.id,
        title: variant.title,
        options: variant.options,
        available: variant.available,
        price: variant.price
      });
    });
    console.log('Selected values that failed to match:', {
      selectedFrame,
      selectedSize
    });
    console.log('Product options structure:', variantData.options);
    
    return null;
  }

  function addToCart(modal) {
    const productId = modal.id.replace('quick-add-modal-', '');
    console.log('Adding to cart for product:', productId);

    const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
    const originalText = addToCartBtn.textContent;

    if (addToCartBtn.disabled) return;

    const variantDataScript = document.getElementById(`product-variants-${productId}`);
    if (!variantDataScript) {
      console.error('No variant data found for validation');
      addToCartBtn.textContent = 'ERROR - NO DATA';
      addToCartBtn.disabled = true;
      return;
    }

    const variantData = JSON.parse(variantDataScript.textContent);
    const { selectedValues, allSelected } = getSelectedOptionsFromVariantSelects(modal, variantData);

    if (!allSelected) {
      updateButtonState(addToCartBtn, false, 'SELECT OPTIONS');
      return;
    }

    const matchingVariant = findVariantByOrderedValues(variantData, selectedValues);
    if (!matchingVariant || matchingVariant.available !== true) {
      updateButtonState(addToCartBtn, false, 'NOT AVAILABLE');
      return;
    }

    // Show loading state and add to cart
    addToCartBtn.textContent = 'ADDING...';
    addToCartBtn.disabled = true;
    addToCartWithVariant(modal, matchingVariant.id);
  }
  
  function useFirstAvailableVariant(modal, productId) {
    console.log('Using first available variant for product:', productId);
    
    // Try to get product handle from the quick add button
    const quickAddButton = document.querySelector(`[data-product-id="${productId}"]`);
    const productHandle = quickAddButton?.getAttribute('data-product-handle');
    
    const productUrl = productHandle ? `/products/${productHandle}.js` : `/products/${productId}.js`;
    console.log('Fetching product from:', productUrl);
    
    fetch(productUrl)
      .then(response => {
        console.log('Product API response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data:', product);
        const firstVariant = product.variants.find(variant => variant.available);
        if (firstVariant) {
          console.log('Using first available variant:', firstVariant);
          addToCartWithVariant(modal, firstVariant.id);
        } else {
          console.error('No available variants found');
          const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
          addToCartBtn.textContent = 'ERROR - NO VARIANTS';
          addToCartBtn.disabled = false;
        }
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
        addToCartBtn.textContent = 'ERROR - PRODUCT NOT FOUND';
        addToCartBtn.disabled = false;
      });
  }
  
  function fetchProductByHandle(productHandle, modal) {
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        console.log('Product API response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data:', product);
        const firstVariant = product.variants.find(variant => variant.available);
        if (firstVariant) {
          console.log('Using first available variant:', firstVariant);
          addToCartWithVariant(modal, firstVariant.id);
        } else {
          console.error('No available variants found');
          const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
          addToCartBtn.textContent = 'ERROR - NO VARIANTS';
          addToCartBtn.disabled = false;
        }
      })
      .catch(error => {
        console.error('Error fetching product by handle:', error);
        const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
        addToCartBtn.textContent = 'ERROR - PRODUCT NOT FOUND';
        addToCartBtn.disabled = false;
      });
  }
  
  function fetchProductById(productId, modal) {
    fetch(`/products/${productId}.js`)
      .then(response => {
        console.log('Product API response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data:', product);
        const firstVariant = product.variants.find(variant => variant.available);
        if (firstVariant) {
          console.log('Using first available variant:', firstVariant);
          addToCartWithVariant(modal, firstVariant.id);
        } else {
          console.error('No available variants found');
          const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
          addToCartBtn.textContent = 'ERROR - NO VARIANTS';
          addToCartBtn.disabled = false;
        }
      })
      .catch(error => {
        console.error('Error fetching product by ID:', error);
        const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
        addToCartBtn.textContent = 'ERROR - PRODUCT NOT FOUND';
        addToCartBtn.disabled = false;
      });
  }
  
  function findMatchingVariant(productId, selectedFrame, selectedSize) {
    console.log('Finding variant for:', { productId, selectedFrame, selectedSize });
    
    // Try to get product handle first
    const quickAddButton = document.querySelector(`[data-product-id="${productId}"]`);
    const productHandle = quickAddButton?.getAttribute('data-product-handle');
    
    const productUrl = productHandle ? `/products/${productHandle}.js` : `/products/${productId}.js`;
    console.log('Fetching product from:', productUrl);
    
    return fetch(productUrl)
      .then(response => {
        console.log('Product API response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data:', product);
        console.log('Product options:', product.options);
        console.log('All variants:', product.variants.map(v => ({
          id: v.id,
          title: v.title,
          options: v.options,
          available: v.available
        })));
        
        // Find variant that matches both frame and size
        const matchingVariant = product.variants.find(variant => {
          console.log('Checking variant:', variant.title, 'options:', variant.options);
          
          // Check if variant has both selected frame and size
          const hasFrame = variant.options.includes(selectedFrame);
          const hasSize = variant.options.includes(selectedSize);
          
          console.log(`Variant ${variant.title}: hasFrame=${hasFrame}, hasSize=${hasSize}`);
          console.log(`Looking for frame: "${selectedFrame}", size: "${selectedSize}"`);
          console.log(`Variant options: [${variant.options.join(', ')}]`);
          
          return hasFrame && hasSize;
        });
        
        if (matchingVariant) {
          console.log('Found matching variant:', matchingVariant);
          return matchingVariant.id;
        }
        
        console.error('No matching variant found');
        console.error('Available variants:', product.variants.map(v => ({
          title: v.title,
          options: v.options
        })));
        return null;
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        return null;
      });
  }
  
  function fetchProductByHandle(productHandle, modal) {
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        console.log('Product API response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data:', product);
        addProductToCart(product, modal);
      })
      .catch(error => {
        console.error('Error fetching product by handle:', error);
        const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
        addToCartBtn.textContent = 'ERROR - PRODUCT NOT FOUND';
        addToCartBtn.disabled = false;
      });
  }
  
  function fetchProductById(productId, modal) {
    fetch(`/products/${productId}.js`)
      .then(response => {
        console.log('Product API response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data:', product);
        addProductToCart(product, modal);
      })
      .catch(error => {
        console.error('Error fetching product by ID:', error);
        const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
        addToCartBtn.textContent = 'ERROR - PRODUCT NOT FOUND';
        addToCartBtn.disabled = false;
      });
  }
  
  function addProductToCart(product, modal) {
    // Get the first available variant
    const firstVariant = product.variants.find(variant => variant.available);
    if (!firstVariant) {
      console.error('No available variants found');
      const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
      addToCartBtn.textContent = 'ERROR - NO VARIANTS';
      addToCartBtn.disabled = false;
      return;
    }
    
    console.log('Using first available variant:', firstVariant);
    addToCartWithVariant(modal, firstVariant.id);
  }
  
  function findMatchingVariantSimple(productId, selectedOptions) {
    console.log('Finding variant for product:', productId, 'with options:', selectedOptions);
    
    return fetch(`/products/${productId}.js`)
      .then(response => response.json())
      .then(product => {
        console.log('Product data:', product);
        
        // Debug: Show all product options and variants
        console.log('=== PRODUCT DEBUG INFO ===');
        console.log('Product options:', product.options);
        console.log('Product variants:', product.variants.map(v => ({
          id: v.id,
          title: v.title,
          options: v.options,
          available: v.available
        })));
        console.log('Selected options:', selectedOptions);
        console.log('========================');
        
        // Simple approach: find variant that matches ALL selected options
        const matchingVariant = product.variants.find(variant => {
          console.log('Checking variant:', variant.title, 'with options:', variant.options);
          
          // Check if this variant matches all selected options
          const matches = Object.keys(selectedOptions).every(optionName => {
            const optionIndex = product.options.findIndex(option => 
              option.name.toLowerCase() === optionName.toLowerCase()
            );
            
            console.log(`Looking for option "${optionName}" in product options:`, product.options.map(o => o.name));
            console.log(`Found option index: ${optionIndex}`);
            
            if (optionIndex === -1) {
              console.log(`Option ${optionName} not found in product options`);
              return false;
            }
            
            const variantValue = variant.options[optionIndex];
            const selectedValue = selectedOptions[optionName];
            
            console.log(`Checking ${optionName}: variant="${variantValue}" vs selected="${selectedValue}"`);
            console.log(`Match: ${variantValue === selectedValue}`);
            
            return variantValue === selectedValue;
          });
          
          console.log('Variant matches all options:', matches);
          return matches;
        });
        
        if (matchingVariant) {
          console.log('Found matching variant:', matchingVariant);
          return matchingVariant.id;
        }
        
        console.error('No exact matching variant found, trying flexible matching...');
        
        // Try flexible matching - match any variant that has the selected size
        const flexibleMatch = product.variants.find(variant => {
          console.log('Flexible check for variant:', variant.title, 'with options:', variant.options);
          
          // Check if any of the variant options match any of our selected options
          const hasMatch = Object.values(selectedOptions).some(selectedValue => {
            const hasValue = variant.options.includes(selectedValue);
            console.log(`Variant has "${selectedValue}": ${hasValue}`);
            return hasValue;
          });
          
          console.log('Variant has any matching option:', hasMatch);
          return hasMatch;
        });
        
        if (flexibleMatch) {
          console.log('Found flexible match:', flexibleMatch);
          return flexibleMatch.id;
        }
        
        console.error('No matching variant found with any approach');
        return null;
      })
      .catch(error => {
        console.error('Error fetching product data:', error);
        return null;
      });
  }
  
  function addToCartWithVariant(modal, variantId) {
    console.log('Adding to cart with variant ID:', variantId);
    
    // Get the add to cart button
    const addToCartBtn = modal.querySelector('.quick-add-popup-add-to-cart');
    const originalText = addToCartBtn.textContent;
    
    // Show loading state
    addToCartBtn.textContent = 'ADDING...';
    addToCartBtn.disabled = true;
    
    // Create form data for Shopify cart
    const formData = {
      'items': [{
        'id': parseInt(variantId),
        'quantity': 1
      }]
    };
    
    console.log('Sending to cart:', formData);
    
    // Add to cart using Shopify's cart API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log('Cart API response status:', response.status);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Successfully added to cart:', data);
      showSuccessMessage(modal, addToCartBtn, originalText);
      
      // Trigger cart update events
      triggerCartUpdate();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      addToCartBtn.textContent = 'ERROR - TRY AGAIN';
      addToCartBtn.style.background = '#dc3545';
      setTimeout(() => {
        addToCartBtn.textContent = 'ADD TO CART';
        addToCartBtn.disabled = false;
        addToCartBtn.style.background = '#dc3545';
      }, 2000);
    });
  }
  
  function getSelectedOptions(modal) {
    const options = {};
    
    // Get selected size button
    const selectedSizeButton = modal.querySelector('.quick-add-popup-size-btn.active');
    if (selectedSizeButton) {
      const optionName = selectedSizeButton.dataset.optionName;
      const optionValue = selectedSizeButton.dataset.optionValue;
      options[optionName] = optionValue;
      console.log('Size option selected:', optionName, '=', optionValue);
    }
    
    // Get selected radio buttons
    const selectedRadios = modal.querySelectorAll('input[type="radio"]:checked');
    selectedRadios.forEach(radio => {
      const optionName = radio.name.replace(`-${modal.id.replace('quick-add-modal-', '')}`, '');
      options[optionName] = radio.value;
      console.log('Radio option selected:', optionName, '=', radio.value);
    });
    
    console.log('All selected options:', options);
    return options;
  }
  
  function findMatchingVariant(productId, selectedOptions) {
    console.log('Finding variant for product:', productId, 'with options:', selectedOptions);
    
    return fetch(`/products/${productId}.js`)
      .then(response => {
        console.log('Product API response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data:', product);
        console.log('Product options:', product.options);
        console.log('Product variants:', product.variants);
        
        // Find matching variant
        const matchingVariant = product.variants.find(variant => {
          console.log('Checking variant:', variant);
          console.log('Variant options:', variant.options);
          
          const matches = Object.keys(selectedOptions).every(optionName => {
            const optionIndex = product.options.findIndex(option => 
              option.name.toLowerCase() === optionName.toLowerCase()
            );
            console.log(`Option ${optionName} index:`, optionIndex);
            console.log(`Variant option value:`, variant.options[optionIndex]);
            console.log(`Selected option value:`, selectedOptions[optionName]);
            
            // More flexible matching - try exact match first, then case-insensitive
            const variantValue = variant.options[optionIndex];
            const selectedValue = selectedOptions[optionName];
            
            const exactMatch = variantValue === selectedValue;
            const caseInsensitiveMatch = variantValue && selectedValue && 
              variantValue.toLowerCase() === selectedValue.toLowerCase();
            
            const isMatch = optionIndex !== -1 && (exactMatch || caseInsensitiveMatch);
            console.log(`Option ${optionName} exact match:`, exactMatch);
            console.log(`Option ${optionName} case-insensitive match:`, caseInsensitiveMatch);
            console.log(`Option ${optionName} final match:`, isMatch);
            return isMatch;
          });
          
          console.log('Variant matches all options:', matches);
          return matches;
        });
        
        if (matchingVariant) {
          console.log('Found matching variant:', matchingVariant);
          return matchingVariant.id;
        }
        
        console.error('No matching variant found');
        console.error('Available variants:', product.variants.map(v => ({ id: v.id, options: v.options })));
        
        // Debug: show all variants with their options
        console.log('=== DEBUG: All Variants ===');
        product.variants.forEach((variant, index) => {
          console.log(`Variant ${index}:`, {
            id: variant.id,
            title: variant.title,
            options: variant.options,
            available: variant.available
          });
        });
        console.log('=== DEBUG: Product Options ===');
        product.options.forEach((option, index) => {
          console.log(`Option ${index}:`, {
            name: option.name,
            values: option.values
          });
        });
        console.log('=== DEBUG: Selected Options ===');
        console.log('Selected:', selectedOptions);
        
        console.error('No matching variant found');
        return null;
      })
      .catch(error => {
        console.error('Error fetching product data:', error);
        return null;
      });
  }
  
  function showSuccessMessage(modal, addToCartBtn, originalText) {
    addToCartBtn.textContent = 'ADDED TO CART!';
    addToCartBtn.style.background = '#28a745';
    
    // Close popup after delay
    setTimeout(() => {
      closePopup();
      // Reset button
      addToCartBtn.textContent = originalText;
      addToCartBtn.disabled = false;
      addToCartBtn.style.background = '#dc3545';
    }, 1500);
  }
  
  function triggerCartUpdate() {
    console.log('Triggering cart update...');
    
    // Trigger custom cart update event
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    // Trigger Shopify's cart update events
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    
    // Update cart count if cart drawer exists
    updateCartCount();
    
    // Show cart notification if it exists
    showCartNotification();
  }
  
  function updateCartCount() {
    // Try to update cart count in header/cart drawer
    const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]');
    cartCountElements.forEach(element => {
      // Fetch current cart count
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          element.textContent = cart.item_count;
          console.log('Updated cart count to:', cart.item_count);
        })
        .catch(error => {
          console.error('Error updating cart count:', error);
        });
    });
  }
  
  function showCartNotification() {
    // Try to show cart notification
    const cartNotification = document.querySelector('.cart-notification, .cart-drawer, .cart-popup');
    if (cartNotification) {
      cartNotification.classList.add('active', 'show');
      console.log('Showing cart notification');
      
      // Hide after delay
      setTimeout(() => {
        cartNotification.classList.remove('active', 'show');
      }, 3000);
    }
  }
  
  function resetForm(modal) {
    console.log('resetForm called');
    
    // Directly evaluate availability based on any default selections present
    setTimeout(() => {
      checkVariantAvailability(modal);
    }, 50);
  }

  // New: handle variant change inside popup variant-selects
  function handleVariantChange(modal) {
    checkVariantAvailability(modal);
  }

  // New: read selected option values in the order of product options
  function getSelectedOptionsFromVariantSelects(modal, variantData) {
    const selectedValues = [];
    let allSelected = true;

    variantData.options.forEach((opt) => {
      const name = opt.name;
      const radio = modal.querySelector(`variant-selects input[name="options[${cssEscape(name)}]"]:checked`);
      const select = modal.querySelector(`variant-selects select[name="options[${cssEscape(name)}]"]`);
      let value = null;
      if (radio) value = radio.value;
      else if (select) value = select.value;
      if (value == null || value === '') allSelected = false;
      selectedValues.push(value);
    });

    return { selectedValues, allSelected };
  }

  // New: match variant by ordered option values
  function findVariantByOrderedValues(variantData, selectedValues) {
    const norm = (s) => (typeof s === 'string' ? s.trim().toLowerCase() : s);
    return variantData.variants.find((v) => {
      return v.options.every((val, idx) => norm(val) === norm(selectedValues[idx]));
    }) || null;
  }

  // Minimal CSS.escape polyfill for attribute selectors
  function cssEscape(str) {
    return String(str).replace(/([\"\\\[\]\(\)\.#\:\,\|])/g, '\\$1');
  }
  
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initQuickAddPopup, 100);
    });
  } else {
    setTimeout(initQuickAddPopup, 100);
  }
})();